export default {
  data() {
    return {
      themeMode: localStorage.getItem('theme'),
    };
  },
  computed: {
    returnMode() {
      return localStorage.getItem('theme');
    },
  },
  methods: {
    makeShades(color) {
      let alpha = 0;
      let cc = '';
      const stepSize = Math.floor((255 / 20));
      for (let i = 0; i < 20; i += 1) {
        let colorIndex = `${(i * 10) / 2}`;
        if (i <= 1) {
          colorIndex = `0${colorIndex}`;
          cc = `#0${(alpha).toString(16)}0${(alpha).toString(16)}0${(alpha).toString(16)}`;
        } else {
          colorIndex = colorIndex.replace('0', '');
          cc = `#${(alpha).toString(16)}${(alpha).toString(16)}${(alpha).toString(16)}`;
        }
        document.body.style.setProperty(`--${color}${colorIndex}`, `${cc}`);
        alpha += stepSize;
      }
      alpha = 0;
    },
    setShadesForColor(color, code) {
      let alpha = 0;
      let colorCode = '';
      const stepSize = Math.floor((255 / 20));
      for (let i = 0; i < 20; i += 1) {
        let colorIndex = `${(i * 10) / 2}`;
        colorCode = `${code}00`;
        if (i === 1) {
          colorIndex = `0${colorIndex}`;
          colorCode = `${code}0${(alpha).toString(16)}`;
        } else if (i > 1) {
          colorIndex = colorIndex.replace('0', '');
          colorCode = `${code}${(alpha).toString(16)}`;
        }
        document.body.style.setProperty(`--${color}${colorIndex}`, `${colorCode}`);
        alpha += stepSize;
      }
      alpha = 0;
    },
    setTheme(appDefinition) {
      this.makeShades('gray');
      // setTheme
      document.body.style.setProperty('--primary', appDefinition.theme.primary);
      document.body.style.setProperty('--primaryDark', appDefinition.theme.primaryDark);
      document.body.style.setProperty('--secondary', appDefinition.theme.secondary);
      document.body.style.setProperty('--secondaryDark', appDefinition.theme.secondaryDark);
      document.body.style.setProperty('--normalText', appDefinition.theme.normalText);
      document.body.style.setProperty('--darkText', appDefinition.theme.darkText);
      document.body.style.setProperty('--invertText', appDefinition.theme.invertText);
      document.body.style.setProperty('--themeBackground', appDefinition.theme.themeBackground);
      document.body.style.setProperty('--themeSurface', appDefinition.theme.themeSurface);
      document.body.style.setProperty('--themeGreen', appDefinition.theme.themeGreen);
      document.body.style.setProperty('--themeRed', appDefinition.theme.themeRed);
      document.body.style.setProperty('--themeOrange', appDefinition.theme.themeOrange);
      document.body.style.setProperty('--shade0', appDefinition.theme.shade0);
      document.body.style.setProperty('--shade1', appDefinition.theme.shade1);
      document.body.style.setProperty('--shade2', appDefinition.theme.shade2);
      document.body.style.setProperty('--shade3', appDefinition.theme.shade3);
      document.body.style.setProperty('--shade4', appDefinition.theme.shade4);
      document.body.style.setProperty('--shade5', appDefinition.theme.shade5);
      document.body.style.setProperty('--themeWhite', appDefinition.theme.themeWhite);
      document.body.style.setProperty('--themeBlack', appDefinition.theme.themeBlack);
      document.body.style.setProperty('--themeBlue', appDefinition.theme.themeBlue);
      document.body.style.setProperty('--color1', appDefinition.theme.color1);
      document.body.style.setProperty('--color2', appDefinition.theme.color2);
      document.body.style.setProperty('--color3', appDefinition.theme.color3);
      document.body.style.setProperty('--color4', appDefinition.theme.color4);
      document.body.style.setProperty('--color5', appDefinition.theme.color5);
      document.body.style.setProperty('--color6', appDefinition.theme.color6);
      document.body.style.setProperty('--color7', appDefinition.theme.color7);
      document.body.style.setProperty('--color8', appDefinition.theme.color8);
      document.body.style.setProperty('--color9', appDefinition.theme.color9);
      document.body.style.setProperty('--color10', appDefinition.theme.color10);
      // setShades
      this.setShadesForColor('primary', appDefinition.theme.primary);
      this.setShadesForColor('primaryDark', appDefinition.theme.primaryDark);
      this.setShadesForColor('secondary', appDefinition.theme.secondary);
      this.setShadesForColor('secondaryDark', appDefinition.theme.secondaryDark);
      this.setShadesForColor('normalText', appDefinition.theme.normalText);
      this.setShadesForColor('darkText', appDefinition.theme.darkText);
      this.setShadesForColor('invertText', appDefinition.theme.invertText);
      this.setShadesForColor('themeSurface', appDefinition.theme.themeSurface);
      this.setShadesForColor('themeBackground', appDefinition.theme.themeBackground);
      this.setShadesForColor('themeGreen', appDefinition.theme.themeGreen);
      this.setShadesForColor('themeRed', appDefinition.theme.themeRed);
      this.setShadesForColor('themeOrange', appDefinition.theme.themeOrange);
      this.setShadesForColor('shade0', appDefinition.theme.shade0);
      this.setShadesForColor('shade1', appDefinition.theme.shade1);
      this.setShadesForColor('shade2', appDefinition.theme.shade2);
      this.setShadesForColor('shade3', appDefinition.theme.shade3);
      this.setShadesForColor('shade4', appDefinition.theme.shade4);
      this.setShadesForColor('shade5', appDefinition.theme.shade5);
      this.setShadesForColor('themeWhite', appDefinition.theme.themeWhite);
      this.setShadesForColor('themeBlack', appDefinition.theme.themeBlack);
      this.setShadesForColor('themeBlue', appDefinition.theme.themeBlue);
      this.setShadesForColor('color1', appDefinition.theme.color1);
      this.setShadesForColor('color2', appDefinition.theme.color2);
      this.setShadesForColor('color3', appDefinition.theme.color3);
      this.setShadesForColor('color4', appDefinition.theme.color4);
      this.setShadesForColor('color5', appDefinition.theme.color5);
      this.setShadesForColor('color6', appDefinition.theme.color6);
      this.setShadesForColor('color7', appDefinition.theme.color7);
      this.setShadesForColor('color8', appDefinition.theme.color8);
      this.setShadesForColor('color9', appDefinition.theme.color9);
      this.setShadesForColor('color10', appDefinition.theme.color10);
    },
    ThemeInit() {
      const project = [
        {
          name: 'rimik',
          faName: 'ریمیـــک',
          primary: '#61187a',
          primaryDark: '#1e2e67',
          secondary: '#2e003d',
          secondaryDark: '#aa8030',
        },
        {
          name: 'verta',
          faName: 'ورتـــا',
          primary: '#61187a',
          primaryDark: '#1e2e67',
          secondary: '#2e003d',
          secondaryDark: '#aa8030',
        },
        {
          name: 'drsinbe',
          faName: 'دکتر بشیرپور',
          primary: '#333333',
          primaryDark: '#303030',
          secondary: '#d6b844',
          secondaryDark: '#b79c34',
        },
        {
          name: 'eej',
          faName: 'سامانه ارتباط الکترونیک جامع',
          primary: '#402f93',
          primaryDark: '#352874',
          secondary: '#64174c',
          secondaryDark: '#4d163c',
        },
      ];
      const projectIndex = 3;
      const appDefinition = {
        name: project[projectIndex].name,
        faName: project[projectIndex].faName,
        url: `https://api.${project[projectIndex].name}.ir`,
        home: `https://panel.${project[projectIndex].name}.ir`,
        site: `https://${project[projectIndex].name}.ir`,
        theme: {},
      };
      let savedTheme = localStorage.getItem('theme');
      if (savedTheme !== 'light' && savedTheme !== 'dark') {
        savedTheme = 'light';
        this.themeMode = 'light';
        localStorage.setItem('theme', savedTheme);
      }
      const themeDark = {
        mode: 'dark',
        primary: project[projectIndex].primary,
        primaryDark: project[projectIndex].primaryDark,
        secondary: project[projectIndex].secondary,
        secondaryDark: project[projectIndex].secondaryDark,
        normalText: '#fefefe',
        darkText: '#f0f0f0',
        invertText: '#131313',
        themeBackground: '#131313',
        themeSurface: '#232323',
        themeGreen: '#40aa45',
        themeRed: '#be2c00',
        themeOrange: '#cfa122',
        shade0: '#0f0f0f',
        shade1: '#2b2b2b',
        shade2: '#3f3f3f',
        shade3: '#4f4f4f',
        shade4: '#6f6f6f',
        shade5: '#808080',
        themeWhite: '#f8f8f8',
        themeBlack: '#0f0f0f',
        themeBlue: '#2841a7',
        color1: '#9B6CAD',
        color2: '#ffd257',
        color3: '#6a2f82',
        color4: '#2b5776',
        color5: '#224f3c',
        color6: '#534636',
        color7: '#4d965f',
        color8: '#6a5b47',
        color9: '#3f4391',
        color10: '#51268c',
      };
      const themeLight = {
        mode: 'light',
        primary: project[projectIndex].primary,
        primaryDark: project[projectIndex].primaryDark,
        secondary: project[projectIndex].secondary,
        secondaryDark: project[projectIndex].secondaryDark,
        normalText: '#222222',
        darkText: '#131313',
        invertText: '#f0f0f0',
        themeBackground: '#e8e8e8',
        themeSurface: '#fefefe',
        themeGreen: '#40aa45',
        themeRed: '#be2c00',
        themeOrange: '#cfa122',
        shade0: '#0f0f0f',
        shade1: '#2b2b2b',
        shade2: '#3f3f3f',
        shade3: '#4f4f4f',
        shade4: '#6f6f6f',
        shade5: '#808080',
        themeWhite: '#f8f8f8',
        themeBlack: '#0f0f0f',
        themeBlue: '#2841a7',
        color1: '#9B6CAD',
        color2: '#ffd257',
        color3: '#6a2f82',
        color4: '#2b5776',
        color5: '#224f3c',
        color6: '#534636',
        color7: '#4d965f',
        color8: '#6a5b47',
        color9: '#3f4391',
        color10: '#51268c',
      };
      if (savedTheme === 'light') {
        appDefinition.theme = themeLight;
      } else if (savedTheme === 'dark') {
        appDefinition.theme = themeDark;
      }
      this.$store.commit('setAppName', appDefinition);
      const title = `کلاس مجازی ${appDefinition.faName}`;
      document.title = title;
      this.themeMode = savedTheme;
      console.log(this.themeMode);
      this.setTheme(appDefinition);
    },
    setThemeTo(mode) {
      localStorage.setItem('theme', mode);
      this.ThemeInit();
    },
  },
};
